import { render, staticRenderFns } from "./yc-put.vue?vue&type=template&id=682e6787&scoped=true&"
import script from "./yc-put.vue?vue&type=script&lang=js&"
export * from "./yc-put.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "682e6787",
  null
  
)

export default component.exports